import Banner from "./Banner";
import ProjectInformation from "./ProjectInformation";
import Gallery from "./Gallery";
import ProjectDetails from "./ProjectDetails";
import Facilities from "./Facilities";
import SpecialArea from "./SpecialArea";
import Location from "./Location";
import BookingGuide from "./BookingGuide";
import { useTranslation } from "react-i18next";
import { galleryData } from "../../../data/home";
import { useState, useRef, useEffect } from "react";
import "./style.scss";
import Cookies from "universal-cookie";

export default function Home() {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const node = useRef(null);
    const cookies = new Cookies();
    const auth = cookies.get("authToken");

    const [isLazyLoadVideo, setIsLazyLoadVideo] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsLazyLoadVideo(true);
        }, 3000);

        let nowDate = new Date();
        let now = nowDate.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
        let nowTimeStamp = new Date(now).getTime();
        let openTime = new Date(2023, 8, 13, 15, 0, 0);
        let openTimeStamp = openTime.getTime();
        if (nowTimeStamp > openTimeStamp) {
            setIsOpen(true);
        }
    }, []);

    return (
        <div className="page-home">
            <img
                src="/img/banner.jpg"
                alt=""
                style={{
                    width: "100%",
                    height: "calc(100vh - 70px)",
                    marginTop: "70px",
                    display: "block",
                    objectFit: "cover",
                }}
            />
        </div>
    );
}
